import { render, staticRenderFns } from "./chebyshevMatch.vue?vue&type=template&id=525ffe5e&scoped=true&"
import script from "./chebyshevMatch.vue?vue&type=script&lang=js&"
export * from "./chebyshevMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ffe5e",
  null
  
)

export default component.exports